import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { NavLink } from 'react-router-dom';
import Loading from '../../Common/components/Loading';
import useFeatureFlagManagment from './hooks/useFeatureFlagManagement';
import RoleFeatureFlagAssociationInput from './RoleFeatureFlagAssociationInput';
import { Button } from '@/src/shadComponents/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/src/shadComponents/ui/card';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@/src/shadComponents/ui/table';

export default function EditRoleFeatureFlagAssociation() {
    const { id, name } = useParams();

    const {
        isLoading,
        setIsLoading,
        getFeatureFlagsForRole,
        fetchFeatureFlags,
    } = useFeatureFlagManagment();

    const [associations, setAssociations] = useState<any[]>([]);
    const [featureFlags, setFeatureFlags] = useState<any[]>([]);

    useEffect(() => {
        let isMounted = true;
        const load = async () => {
            try {
                const associations = await getFeatureFlagsForRole(
                    id ? +id : -1,
                );
                const featureFlags = await fetchFeatureFlags();

                isMounted && setAssociations(associations);
                isMounted && setFeatureFlags(featureFlags);
            } catch (error) {
                console.error('Failed to load assocaiations', error);
            } finally {
                isMounted && setIsLoading(false);
            }
        };

        load();
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return <Loading isLoading={isLoading} />;
    }

    return (
        <div className="p-4">
            <Card>
                <CardHeader>
                    <CardTitle className="text-2xl capitalize">
                        {name} role association
                    </CardTitle>
                    <CardDescription>
                        Manage feature flag associations for this role.
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>Feature Flag</TableHead>
                                <TableHead>Enabled</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {featureFlags.map((flag) => {
                                return (
                                    <TableRow key={flag.id}>
                                        <TableCell>{flag.key}</TableCell>
                                        <TableCell>
                                            <RoleFeatureFlagAssociationInput
                                                checked={associations.includes(
                                                    flag.key,
                                                )}
                                                roleId={id ? +id : -1}
                                                keyId={flag.id}
                                            />
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
            <div className="mt-6 flex items-center justify-end gap-x-6 px-6 fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background p-3">
                <NavLink to="/admin/features">
                    <Button>
                        Done
                    </Button>
                </NavLink>
            </div>
        </div>
    );
}
